<template>
  <label
    class="m-0 inline-flex items-center text-sm"
    :class="{ 'font-medium': !isCheckboxLabel }"
    :for="id"
  >
    <slot />
    <span v-if="isRequired" class="text-error-500 ml-1">*</span>
    <QuestionMarkTooltip v-if="tooltip" :tooltip="tooltip" class="ml-1" />
  </label>
</template>

<script setup>
import QuestionMarkTooltip from '@/shared/components/QuestionMarkTooltip.vue'

defineProps({
  id: {
    type: String,
    required: true,
  },
  isRequired: {
    type: Boolean,
    default: false,
  },
  tooltip: {
    type: String,
    default: '',
  },
  isCheckboxLabel: {
    type: Boolean,
    default: false,
  },
})
</script>
